export default __webpack_public_path__ + "static/Group 16-2fe2ddf2b9e83012229f469404628505.jpg";